//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ContentHeader from 'components/ContentHeader'
import Vue from 'vue'
import $ from 'jquery'
import DateRangePicker from 'components/DateRangePicker'
import SortOrderTableTh from 'components/SortOrderTableTh'

const Pagination = require('../plugins/vue-bootstrap-paginator').default

export default {
  components: {
    ContentHeader,
    Pagination,
    DateRangePicker,
    SortOrderTableTh
  },
  data () {
    return {
      sortParams: {},
      searchBindingId: '',
      newBindingId: '',
      addCoinAmount: 0,
      searchDate: {startDate: '', endDate: '', startDateText: '', endDateText: ''},
      dateOptions: JSON.parse(JSON.stringify(this.dateRangePickerOptions)),
      playerList: [],
      user: {},
      totalItems: 0,
      currentPage: 1,
      perPage: 0,
      appointPage: 1,
      lastPage: 0
    }
  },
  created () {
  },
  mounted () {
    this.getPlayerList();
  },
  computed: {
  },
  methods: {
    // 获取用户列表
    getPlayerList: function (page = 1, sortParams) {
      let $this = this
      if (sortParams === undefined) {
        sortParams = this.sortParams;
      }
      var params = {
        page: page,
        binding_id: this.searchBindingId,
        sort_column: sortParams.sortColumn,
        sort_type: sortParams.sortType,
        sdate: this.searchDate.startDateText,
        edate: this.searchDate.endDateText
      }
      Vue.http.get(this.serviceUrl('api/player/list'), {params: params}).then((response) => {
        let resp = response.data
        $this.playerList = resp.playerList.data;
        $this.totalItems = resp.playerList.total;
        $this.currentPage = resp.playerList.current_page;
        $this.perPage = resp.playerList.per_page;
        $this.lastPage = resp.playerList.last_page;
      })
    },
    // 分页跳转
    pageChanged: function (page = 1) {
      this.getPlayerList(page)
    },
    // 跳转指定页面
    pageJumped: function () {
      var appointPage = parseInt(this.appointPage) < this.lastPage ? parseInt(this.appointPage) : this.lastPage;
      this.getPlayerList(appointPage);
    },
    onSortOrder: function (params, event) {
      this.sortParams = params
      this.getPlayerList(1, params);
    },
    // 赋值
    assignInfo: function (row) {
      this.user = row;
    },
    // 新增玩家
    addPlayer: function () {
      let $this = this
      var bindingId = $.trim(this.newBindingId);
      if (!bindingId) {
        $this.alert('接入方唯一标识不能为空', 2);
        return false;
      }
      if (bindingId.length > 64) {
        $this.alert('接入方唯一标识长度不超过64个字节', 2);
        return false;
      }
      if (!confirm('确定新增？')) {
        return false;
      }
      var data = {
        binding_id: bindingId
      }
      Vue.http({
        method: 'POST',
        url: this.serviceUrl('api/player/add'),
        data: data
      }).then((resp) => {
        if (resp.data.errcode === 0) {
          $this.getPlayerList(1);
          $this.newBindingId = '';
          $('.js-add-player-modal').modal('hide');
          $this.alert('充值成功', 1);
        } else {
          $this.alert(resp.data.errmsg, 2);
        }
      })
    },
    // 充值游戏币
    addCoins: function (row) {
      let $this = this
      if (this.addCoinAmount <= 0) {
        $this.alert('充值游戏币需大于0', 2);
        return false;
      }
      if (!confirm('确定为ID为' + row.game_user_id + '的玩家充值' + this.addCoinAmount + '个游戏币？')) {
        return false;
      }
      var data = {
        coins: this.addCoinAmount,
        user_id: row.game_user_id
      }
      Vue.http({
        method: 'PUT',
        url: this.serviceUrl('api/player/recharge/coins'),
        data: data
      }).then((resp) => {
        if (resp.data.errcode === 0) {
          $this.getPlayerList($this.currentPage);
          $this.addCoinAmount = 0;
          $('.js-recharge-modal').modal('hide');
          $this.alert('充值成功', 1);
        } else {
          $this.alert(resp.data.errmsg, 2);
        }
      });
    },
    // 游戏币清零
    clearCoins: function (row) {
      let $this = this
      if (!confirm(`确定清零ID为${row.game_user_id}的玩家的游戏币？`)) {
        return false;
      }
      var data = {
        user_id: row.game_user_id
      }
      Vue.http({
        method: 'PUT',
        url: this.serviceUrl('api/player/clear/coins'),
        data: data
      }).then((resp) => {
        if (resp.data.errcode === 0) {
          $this.getPlayerList($this.currentPage);
          $this.alert('成功清零', 1);
        } else {
          $this.alert(resp.data.errmsg, 2);
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/PageGameUserList.vue